import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const HomeSectionTitle = ({ title }) => {
  const t = useTranslation();

  return (
    <div className="home-section-title">
      <svg xmlns="http://www.w3.org/2000/svg" width="1040" height="4" viewBox="0 0 1040 4" fill="none">
        <path d="M0 2L1040 2.00009" stroke="url(#paint0_radial_11703_11135)" strokeWidth="3" />
        <defs>
          <radialGradient id="paint0_radial_11703_11135" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(520 2.50005) rotate(90) scale(0.5 520)">
            <stop stopColor="rgba(var(--revert-color), 1)" />
            <stop offset="1" stopColor="rgba(var(--revert-color), 1)" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>

      <h1 className="home-section-title-txt">{t(title)}</h1>
    </div>
  );
};

HomeSectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default HomeSectionTitle;
